import { api, encodeFileName } from 'utility';
import queryString from 'query-string';
import {
  getGuildServiceUrl,
  getCreditUrl,
  getUserContactUrl,
  getCreateDeligationUrl,
  getAllBusinessInfoUrl,
  getCarTableListUrl,
  cartableRequestGroupParams,
  getTransferGroupNewUrl,
  getMultipleTransferConfirm,
  getCartableDefineDelegationUrl

} from 'URLs';
const source = api.cancelToken;
let cancelToken;

// Cards
export function checkBalance() {
  return api.get(getCreditUrl()).then((res) => res.data);
}

export function transfer(data) {
  return api.post(getCreateDeligationUrl(), data).then((res) => res.data);
}

export function checkContact(data) {
  return api.post(getUserContactUrl(), data).then((res) => res.data);
}

export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}

export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

/**
   * بررسی اینکه این حساب کارتابل هست یا خیر؟
   */
export function getCarTableList(data, params = {}) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }

  cancelToken = source.source();
  return api.post(getCarTableListUrl(), data, { cancelToken: cancelToken.token, }).then((res) => res.data);
}

/**
 * تفویض کارتابل فردی
 */
export function requestDelegationSingleCartable(data) {
  //const params = { ...obj };
  return api.post(getCartableDefineDelegationUrl(), data).then((res) => res.data);

}
//to do
/**
 * تفویض کارتابل گروهی
 */
export function requestDelegationGroupCartable(formData, body, name, type) {
  let str = queryString.stringify(body);
  return api
    .post(cartableRequestGroupParams(str), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'File-Type': type,
        'file-name': encodeFileName(name)
      },
    })
    .then((res) => res.data);
}

export function delegationGroup( query) {
  return api
    .post(`${getTransferGroupNewUrl()}?${queryString.stringify(query)}`)
    .then((res) => res.data);
}
export function confirmDelegationByGroup(requestId, data, headers = {}) {
  return api.post(getMultipleTransferConfirm(requestId), data, {
    headers: {
      ...headers
    }
  }).then((res) => res.data);
}

export default {
  checkContact,
  checkBalance,
  transfer,
  getBusinessList,
  getGuildsList,
  getCarTableList,
  requestDelegationSingleCartable,
  requestDelegationGroupCartable,
  delegationGroup,
  confirmDelegationByGroup
};
